import { render, staticRenderFns } from "./OrderSingleTransactions.vue?vue&type=template&id=4deae9a6&"
import script from "./OrderSingleTransactions.vue?vue&type=script&lang=js&"
export * from "./OrderSingleTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports